export enum Roles {
    Administrator = 'Administrator',
    Network = 'Advertiser',
    Developer = 'Developer'
}